// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3F-yI","signatureButtonsRight":"ModalSign_signatureButtonsRight__3dMAs"};